import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";
import { Container, Title } from "./styles";

const colors = {
  cpu: "#f59e0b",
  ram: "#10b981",
  gpu: "#8b5cf6",
  vram: "#6366f1",
  xidle: "#0ea5e9",
};

const tickColor = "#334155";
const gridColor = "#e5e7eb";

const swallow = (e: React.SyntheticEvent) => {
  e.preventDefault();
  e.stopPropagation();
};

const MetricChart = ({ title, data }) => {
  return (
    <Container>
      <Title>{title}</Title>

      <div
        onClickCapture={swallow}
        onMouseDownCapture={swallow}
        onMouseUpCapture={swallow}
        onDoubleClickCapture={swallow}
        onContextMenuCapture={swallow}
        style={{ cursor: "default", userSelect: "none" }}
      >
        <ResponsiveContainer width="100%" height={380}>
          <LineChart
            data={data}
            margin={{ top: 8, right: 16, bottom: 0, left: 0 }}
          >
            <CartesianGrid stroke={gridColor} strokeDasharray="3 3" />
            <XAxis
              dataKey="time"
              minTickGap={48}
              tick={{ fill: tickColor, fontSize: 12 }}
              tickLine={false}
              axisLine={{ stroke: gridColor }}
            />
            <YAxis
              domain={[0, 100]}
              tick={{ fill: tickColor, fontSize: 12 }}
              tickFormatter={(v) => `${v}%`}
              tickLine={false}
              axisLine={{ stroke: gridColor }}
              allowDataOverflow
            />
            <Tooltip
              formatter={(value: number, name: string) => [
                `${value}%`,
                name.toUpperCase(),
              ]}
              labelStyle={{ color: "#0f172a", fontWeight: 700 }}
              contentStyle={{
                background: "#ffffff",
                border: "1px solid #e5e7eb",
                borderRadius: 12,
                color: "#334155",
                boxShadow: "0 8px 18px rgba(15, 23, 42, 0.08)",
              }}
            />
            <Legend
              wrapperStyle={{
                color: "#64748b",
                fontSize: 12,
                pointerEvents: "none",
              }}
              iconType="plainline"
            />
            {Object.keys(colors).map((key) => (
              <Line
                key={key}
                type="monotone"
                dataKey={key}
                stroke={colors[key]}
                strokeWidth={2}
                dot={false}
                activeDot={{ r: 3 }}
                isAnimationActive={false}
              />
            ))}
          </LineChart>
        </ResponsiveContainer>
      </div>
    </Container>
  );
};

export default MetricChart;
